import { isValidDate } from '@cian/utils';

import { IDeleteAllImagesFromPostsSettings } from '../../types/applicationContext';

/**
 * Проверяет и правит номер страницы для листинга
 */
export const canDeleteAllImagesFromPosts = (
  postPublicationDate: Date,
  deleteAllImagesFromPostsSettings?: IDeleteAllImagesFromPostsSettings,
) => {
  if (
    !isValidDate(postPublicationDate) ||
    !deleteAllImagesFromPostsSettings?.isEnabled ||
    !deleteAllImagesFromPostsSettings?.beforePublicationDate
  ) {
    return false;
  }

  const beforePublicationDate = new Date(deleteAllImagesFromPostsSettings?.beforePublicationDate);

  if (!isValidDate(beforePublicationDate)) {
    return false;
  }

  return postPublicationDate <= beforePublicationDate;
};
